import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './style.module.css';
import { emailAddressRegex } from 'validation/auth.validation';
import Textfield from 'components/shared/Textfield';
import BackAndNextButton from 'layouts/RegistrationLayoutNew/Buttons/BackAndNextButton';

const EmailAddressInfo = ({
  emailAddress,
  setemailAddress,
  findUserByEmail,
  onNext,
  onBack,
  isMobile,
  isSmallMobile,
  userExistenceData,
}) => {
  const addressInputWidth = isMobile ? '80vw' : isSmallMobile ? '89.4vw' : '55vw';
  const [invalid, setinvalid] = useState(false);
  const [errorMessage, seterrorMessage] = useState('');
  const [shouldRunEffect, setShouldRunEffect] = useState(false);

  const handleEmailValidation = () => {
    if (!emailAddressRegex.test(emailAddress)) {
      setinvalid(true);
      seterrorMessage('Invalid email address');
      return;
    } else {
      findUserByEmail(emailAddress);
    }
  };

  useEffect(() => {
    if (!shouldRunEffect) {
      if (Object.keys(userExistenceData).length !== 0) {
        setShouldRunEffect(true);
      }
    }
    // eslint-disable-next-line
  }, [userExistenceData]);

  useEffect(() => {
    if (shouldRunEffect) {
      onNext();
    }
    // eslint-disable-next-line
  }, [shouldRunEffect]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <div className={`${styles.box} ${isMobile ? styles.mob : ''}`}>
        {isMobile ? <p className={styles.label}>Email</p> : null}

        <Textfield
          boxShadow={'0px 4px 12px rgba(0, 0, 0, 0.08)'}
          onChange={e => setemailAddress(e.target.value)}
          invalid={invalid}
          error={errorMessage}
          value={emailAddress}
          width={addressInputWidth}
          className={` ${styles.input} ${isMobile ? styles.mob : ''} ${
            isSmallMobile ? styles.smallMob : ''
          }`}
        />
      </div>
      <BackAndNextButton
        backButtonName="Back"
        nextButtonName="Next"
        nextButtonDisable={emailAddress === null || emailAddress === ''}
        onBack={onBack}
        onNext={() => handleEmailValidation()}
      />
    </div>
  );
};

EmailAddressInfo.propTypes = {
  onBack: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  emailAddress: PropTypes.string.isRequired,
};

export default EmailAddressInfo;
